import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";

const http = new HttpService();

/**
 * Zap Forms — creator-built sign-up forms behind /form/:slug.
 *
 * The two public calls (getPublicForm / submitForm) are JWT-exempt on the
 * server: they are what a follower's browser hits, and that browser has no
 * ClanConnect session.
 */
export class ZapFormService {

    // ---- Creator ----

    static async saveForm(data: any): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/zap-form/save", data, null);
        } catch (error) { throw new Error(`saveForm: ${error}`); }
    }

    static async getMyForms(influencer_id: number | string): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/zap-form/my?influencer_id=${influencer_id}`, null);
        } catch (error) { throw new Error(`getMyForms: ${error}`); }
    }

    static async checkSlug(slug: string, zap_form_id?: number | string): Promise<any> {
        try {
            return await http.getRequest(
                BASE_URL + `/zap-form/slug-check?slug=${encodeURIComponent(slug)}&zap_form_id=${zap_form_id || 0}`,
                null
            );
        } catch (error) { throw new Error(`checkSlug: ${error}`); }
    }

    static async getSubmissions(params: {
        influencer_id: number | string;
        zap_form_id?: number | string;
        limit?: number;
        offset?: number;
    }): Promise<any> {
        try {
            const query = new URLSearchParams({
                influencer_id: String(params.influencer_id),
                zap_form_id: String(params.zap_form_id || 0),
                limit: String(params.limit ?? 50),
                offset: String(params.offset ?? 0),
            }).toString();
            return await http.getRequest(BASE_URL + `/zap-form/submissions?${query}`, null);
        } catch (error) { throw new Error(`getSubmissions: ${error}`); }
    }

    static async exportSubmissions(influencer_id: number | string, zap_form_id: number | string): Promise<any> {
        try {
            return await http.getRequest(
                BASE_URL + `/zap-form/submissions/export?influencer_id=${influencer_id}&zap_form_id=${zap_form_id}`,
                null
            );
        } catch (error) { throw new Error(`exportSubmissions: ${error}`); }
    }

    // ---- Public (no session) ----

    static async getPublicForm(slug: string): Promise<any> {
        try {
            return await http.getRequest(BASE_URL + `/zap-form/view/${encodeURIComponent(slug)}`, null);
        } catch (error) { throw new Error(`getPublicForm: ${error}`); }
    }

    static async submitForm(data: { slug: string; answers: Record<string, string>; source?: string }): Promise<any> {
        try {
            return await http.postRequest(BASE_URL + "/zap-form/submit", data, null);
        } catch (error) { throw new Error(`submitForm: ${error}`); }
    }
}
